$(document).ready(function() {


	// * * * * * * * * * * * * * * * * * * * * * * * * *
	// * Name
	// *
	// *



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function(e){
        window.location = $(this).attr("href");
        return false;
    }).click(function(){
        window.location = $(this).find("a.js-click-item-link").attr("href");
        return false;
    });​



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page
    // *
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                scrollTo(target);
            return false;
            }
        }
    });

    function scrollTo(element) {
        $('html, body').animate({
            scrollTop: element.offset().top - 100
        }, 1000);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header logo landing page
    // *
    // *
    $(window).scroll(function() {
        if($(window).scrollTop() >= 300) {
            $(".js-header-logo-landing").addClass("active");
        }else {
            $(".js-header-logo-landing").removeClass("active");
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function(){
        $(this).parents(".js-accordion-parent").toggleClass("active").find(".js-accordion-content").slideToggle();
        //$(this).parents(".js-accordion-parent").siblings().removeClass("active").find(".js-accordion-content").slideUp();
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * toggle navigation
    // *
    // *
    $(".js-nav-button").click(function(){
        $(".js-nav").toggleClass("active");
        $("body").toggleClass("freeze");
        $(".js-nav-overlay-close").toggle();
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dateOverlay
    // *
    // *
    $(".js-date-overlay-button").click(function(){
        $(".js-date-overlay-button").toggleClass("active");
        $(".js-date-overlay").toggleClass("active");
        $("body").toggleClass("freeze");
        $(".js-advice-overlay-button").toggle();
    });

    if ($(".js-date-overlay").hasClass("success")) {
        setTimeout(function() {
            $(".js-date-overlay").removeClass("success active");
            $(".js-date-overlay-button").trigger("click");
            $("body").removeClass("freeze");
        }, 4400);
    }

    if ($(".js-date-overlay").hasClass("success") || $(".js-date-overlay").hasClass("active")) {
        $("body").addClass("freeze");
    }





    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contactOverlay
    // *
    // *
    $(".js-contact-overlay-button").click(function(){
        $(".js-contact-overlay").toggleClass("active");
        $("body").toggleClass("freeze");
    });

    if ($(".js-contact-overlay").hasClass("success")) {
        setTimeout(function() {
            $(".js-contact-overlay").removeClass("success active");
            $(".js-contact-overlay-button").trigger("click");
            $("body").removeClass("freeze");
        }, 4400);
    }

    if ($(".js-contact-overlay").hasClass("success") || $(".js-contact-overlay").hasClass("active")) {
        $("body").addClass("freeze");
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * adviceOverlay
    // *
    // *
    $(".js-advice-overlay-button").click(function(){
        $(".js-advice-overlay").toggleClass("active");
        $("body").toggleClass("freeze");
        $(".js-advice-overlay-midlayer").hide();
        $(".js-advice-overlay-overlay").show();
        $(".js-advice-overlay-underlay").hide();
    });

    $(".js-advice-overlay-midlayer-button").click(function(){
        $(".js-advice-overlay-midlayer").fadeToggle();
        $(".js-advice-overlay-overlay").toggle();
    });

    if ($(".js-advice-overlay").hasClass("success")) {
        setTimeout(function() {
            $(".js-advice-overlay").removeClass("success active");
            $("body").removeClass("freeze");
        }, 4400);
    }

    if ($(".js-advice-overlay").hasClass("success") || $(".js-advice-overlay").hasClass("active")) {
        $("body").addClass("freeze");
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * adviceOverlay
    // *
    // *
    $(".js-coaching-overlay-button").click(function(){
        $(".js-coaching-overlay").toggleClass("active");
        $("body").toggleClass("freeze");
        $(".js-coaching-overlay-midlayer").hide();
        $(".js-coaching-overlay-overlay").show();
        $(".js-coaching-overlay-underlay").hide();
    });

    $(".js-coaching-overlay-midlayer-button").click(function(){
        $(".js-coaching-overlay-midlayer").fadeToggle();
        $(".js-coaching-overlay-overlay").toggle();
    });

    if ($(".js-coaching-overlay").hasClass("success")) {
        setTimeout(function() {
            $(".js-coaching-overlay").removeClass("success active");
            $("body").removeClass("freeze");
        }, 4400);
    }

    if ($(".js-coaching-overlay").hasClass("success") || $(".js-coaching-overlay").hasClass("active")) {
        $("body").addClass("freeze");
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Hide Header on on scroll down
    // *
    // *
    var didScroll;
    var lastScrollTop = 0;
    var navbarHeight = $('.js-header').outerHeight();

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (st <= 40) {
            $('.js-header').removeClass('header--navUp').removeClass('header--navDown');
        }

        if (st > lastScrollTop){
            // Scroll Down

            if (st > navbarHeight) {
                $('.js-header').addClass('header--navUp').removeClass('header--navDown');
            }

        }else {
            //Scroll up
            if (st <= (navbarHeight - 60)) {
                $('.js-header').removeClass('header--navUp').removeClass('header--navDown');
            }else {
                if(st + $(window).height() < $(document).height() && st > navbarHeight) {
                    $('.js-header').removeClass('header--navUp').addClass('header--navDown');
                }
            }
        }

        lastScrollTop = st;
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * cookie-message
	// *
	// *
	var cookieMessage = Cookies.get('cookie-message');

	$(".js-cookie-message-btn").click(function(){
		$(this).parents(".js-cookie-message").fadeOut();
		Cookies.set('cookie-message', '1', { expires: 365 });
	});

	if (!cookieMessage) {
		$(".js-cookie-message").show();
	}



    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * animateIn
	// *
	// *
	var offset = 200; /* Abstand vom Browserbottom, wenn Effekt einsetzen soll */

    if ($(window).width() <= 767) {
        var offset = 30;
    }

	function fadeInElements(){
		var viewPort = $(window).scrollTop() + $(window).height();

		$(".animateIn:visible").each(function(){
			var elementTop = $(this).offset().top;

			if ((elementTop + offset) <= viewPort) {
				var delay = $(this).data("animation-delay");
				$(this).css("animation-delay", delay + "s").addClass("animateIn--active");
			}
		});
	}
	$(window).scroll(function() {
		fadeInElements();
	});
	fadeInElements();

});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * ontop
// *
// *

// item select by class "js-ontop-item" (optional: data-ontop="")
// area select by data data-ontop-area="" (oiptional: specific area key)

$(window).on("load resize scroll",function(e){
    $(".js-ontop-item").each(function(){
        var $item = $(this),
            activeArea = false,
            areaKey = $(this).data("ontop"),
            $areaSelector = $('[data-ontop-area]');
            itemTop = parseInt($(this).offset().top),
            itemBottom = parseInt(itemTop + $(this).outerHeight());

        $item.removeClass("ontop");

        if (areaKey.length >= 1) {
            $areaSelector = $('[data-ontop-area=' + areaKey + ']')
        }

        $areaSelector.each(function(){
            var areaTop = parseInt($(this).offset().top),
                areaBottom = parseInt(areaTop + $(this).outerHeight());

            if (activeArea == true) { return true; }

            if ((areaTop >= itemTop && areaTop <= itemBottom) || (areaTop <= itemTop && areaBottom >= itemTop)) {
                $item.addClass("ontop");
                activeArea = true;
                return true;
            }
        });

    });
});
